module.exports = __webpack_public_path__ + "img/COFFEE_HOUSE.da1395f8.png";